import { render, staticRenderFns } from "./AspEvents.vue?vue&type=template&id=2a8f0f10"
import script from "./AspEvents.vue?vue&type=script&lang=js"
export * from "./AspEvents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports